import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class RoleService implements CanActivate {
	constructor(private oidcSecurityService: OidcSecurityService, private router: Router) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean | UrlTree> {
		return this.oidcSecurityService.userData$.pipe(
			map(({ userData }) => {
				console.warn(userData);
				if (userData.roles && userData.roles.length > 0) {
					return true;
				}
				return this.router.parseUrl('/login/no-access');
			}),
		);
	}
}
